import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4cb46b1f = () => interopDefault(import('../pages/error/index.vue' /* webpackChunkName: "pages/error/index" */))
const _6abc5f5d = () => interopDefault(import('../pages/sign-out/index.vue' /* webpackChunkName: "pages/sign-out/index" */))
const _5b9b271f = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _72be9a7c = () => interopDefault(import('../pages/users/create/index.vue' /* webpackChunkName: "pages/users/create/index" */))
const _0548ecf6 = () => interopDefault(import('../pages/users/_username/index.vue' /* webpackChunkName: "pages/users/_username/index" */))
const _27a06b66 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0b489273 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _4cb46b1f,
    name: "error"
  }, {
    path: "/sign-out",
    component: _6abc5f5d,
    name: "sign-out"
  }, {
    path: "/users",
    component: _5b9b271f,
    name: "users"
  }, {
    path: "/users/create",
    component: _72be9a7c,
    name: "users-create"
  }, {
    path: "/users/:username",
    component: _0548ecf6,
    name: "users-username"
  }, {
    path: "/",
    component: _27a06b66,
    name: "index"
  }, {
    path: "/*",
    component: _0b489273,
    name: "all"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
